import { connect } from 'react-redux';
import {SEARCH_QUIZ,ROUTES} from '../constants';
import SearchQuizPage from '../components/pages/SearchQuizPage';

const mapStateToProps = ({searchRecipesReducer,auth,},ownProps) => {
	const fetchingState = searchRecipesReducer.fetchingState;
	const {error,errorMessage} = searchRecipesReducer;
	return {
		...ownProps,
		fetchingState:fetchingState,
		error,
		errorMessage,
		auth,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		requestSearchRefresh : ()=>{
			dispatch({
				type:SEARCH_QUIZ.REFRESH
			});},
		onClickCard : (recipeId)=> {
			dispatch({
				type:ROUTES.RECIPE_DETAIL,
				payload:{
					recipeId
				}
			});
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(SearchQuizPage);